import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: () => import('./views/Home.vue')
  },
  {
    path: '/rentalCar',
    name: 'RentalCar',
    component: () => import('./views/RentalCar.vue')
  },
  {
    path: '/carAftherMarket',
    name: 'CarAftherMarket',
    component: () => import('./views/CarAftherMarket.vue')
  },
  {
    path: '/laLaPartner',
    name: 'LaLaPartner',
    component: () => import('./views/LaLaPartner.vue')
  },
  {
    path: '/addWe',
    name: 'AddWe',
    component: () => import('./views/AddWe.vue')
  },
  {
    path: '/aboutMe',
    name: 'AboutMe',
    component: () => import('./views/AboutMe.vue')
  },
  {
    path: '/userAgreement',
    name: 'UserAgreement',
    component: () => import('./views/UserAgreement.vue')
  },
  {
    path: '/contactWe',
    name: 'ContactWe',
    component: () => import('./views/ContactWe.vue')
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('./views/PrivacyPolicy.vue')
  }]
})

export default kejianrouter